if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();

      var el = this.querySelector('[aria-current="true"]').parentNode;
      this.scrollToActiveSlide(el);      

      this.querySelector('.product__media-list_btn-prev').addEventListener('click', this.btnClickHandlerPrev.bind(this));
      this.querySelector('.product__media-list_btn-next').addEventListener('click', this.btnClickHandlerNext.bind(this));

      // --- Wythout: 1/N counter + gallery autoplay (all widths) ---
      // The crossfade/click-cycle takeover only runs on the redesigned hero
      // PDPs (body.pdp-hero, set via snippets/pdp-hero.liquid) — every other
      // product keeps the stock slider, so the overlay/autoplay never build.
      this.heroTakeover = document.body.classList.contains('pdp-hero');
      this.counter = this.querySelector('.product__media-counter');
      this.mobileSlider = this.elements.viewer.querySelector('.slider--phone');
      this.mediaSlides = Array.from(this.elements.viewer.querySelectorAll('.product__media-item'));
      this.updateCounter();
      if (this.mobileSlider) {
        this.mobileSlider.addEventListener('scroll', () => {
          if (this._counterRaf) return;
          this._counterRaf = requestAnimationFrame(() => {
            this._counterRaf = null;
            this.syncCounterToScroll();
          });
        }, { passive: true });
      }
      if (this.heroTakeover) {
        this.initGalleryClickCycle();
        this.initGalleryAutoplay();
      }
    }
    btnClickHandlerPrev(){
      var q = this.querySelector('[aria-current="true"]').parentNode;
      this.querySelector('[aria-current="true"]').removeAttribute('aria-current');
      var index = Number(Array.prototype.indexOf.call(q.parentElement.children, q))-1;
      if(index<0){
        index=this.querySelector('.thumbnail-slider__list').children.length-1;
      }
      q.parentElement.querySelectorAll('.thumbnail')[index].dispatchEvent(new CustomEvent('click'));
    }
    btnClickHandlerNext(){
      var q = this.querySelector('[aria-current="true"]').parentNode;
      this.querySelector('[aria-current="true"]').removeAttribute('aria-current');
      var index = Number(Array.prototype.indexOf.call(q.parentElement.children, q))+1;
      var max_index = this.querySelector('.thumbnail-slider__list').children.length-1;
      if(index>max_index){
        index=0;
      }
      q.parentElement.querySelectorAll('.thumbnail')[index].dispatchEvent(new CustomEvent('click'));
    }
    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
      this.updateCounter(event.detail.currentElement);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      /*if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }*/
      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      
      /*if(thumbnail.offsetTop < thumbnail.parentElement.scrollTop){
        thumbnail.parentElement.scrollTo({
          top: thumbnail.offsetTop
        });
      }*/
      this.scrollToActiveSlide(thumbnail);
    }
    scrollToActiveSlide(thumbnail){
      var ratio = String(this.querySelector('.slider__slide.is-active').getAttribute('data-aspect-ratio'));
      this.querySelector('.product__media-list').style.setProperty('--ratio', ratio);
      
      var media_container = this.querySelector('.thumbnail-slider__list'),
          _y = thumbnail.offsetTop-media_container.offsetTop,
          _h = media_container.offsetHeight,
          main_scrolltop = media_container.scrollTop,
          item_y = _y-main_scrolltop+thumbnail.offsetHeight,
          temp = 0;
  
      if(item_y > _h){
        temp = main_scrolltop + (item_y-_h);
        this.scrollTo(media_container, temp, 100, 'scrollTop');
      }
      else if(_y < main_scrolltop){
        temp = media_container.scrollTop - (main_scrolltop - _y);
        this.scrollTo(media_container, temp, 100, 'scrollTop');
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    // A slide whose media is playable (video / external video / 3D model) —
    // they all render a .deferred-media wrapper with a poster button.
    isMediaSlide(slide) {
      return !!(slide && slide.querySelector('.deferred-media'));
    }

    // Only issue the document-wide pause when this gallery actually contains
    // playable media — otherwise every crossfade advance would stop unrelated
    // videos elsewhere on the page.
    pausePlayingMedia() {
      if (this.hasPlayableMedia === undefined) {
        this.hasPlayableMedia = !!this.elements.viewer.querySelector('.deferred-media');
      }
      if (this.hasPlayableMedia) window.pauseAllMedia();
    }

    playActiveMedia(activeItem) {
      this.pausePlayingMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }

    scrollTo(el, to, duration, option) {
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      };
  
      const element = el;
      const start = element[option],
            change = to - start,
            increment = 20;
      var currentTime = 0;
      
      const animateScroll = function(){
        currentTime += increment;
        const val = Math.easeInOutQuad(currentTime, start, change, duration);
        element[option] = val;
        if(currentTime < duration) {
          window.setTimeout(animateScroll, increment);
        }
      };
      animateScroll();
    }

    updateCounter(currentEl) {
      if (!this.counter) return;
      const slides = this.mediaSlides && this.mediaSlides.length
        ? this.mediaSlides
        : Array.from(this.elements.viewer.querySelectorAll('.product__media-item'));
      const el = currentEl
        || this.elements.viewer.querySelector('.product__media-item.is-active')
        || slides[0];
      const idx = slides.indexOf(el);
      const current = this.counter.querySelector('.product__media-counter__current');
      if (current && idx >= 0) current.textContent = idx + 1;
    }

    syncCounterToScroll() {
      if (!this.counter || !this.mobileSlider) return;
      const w = this.mobileSlider.clientWidth || 1;
      const total = this.mediaSlides.length;
      const idx = Math.max(0, Math.min(Math.round(this.mobileSlider.scrollLeft / w), total - 1));
      const current = this.counter.querySelector('.product__media-counter__current');
      if (current) current.textContent = idx + 1;
    }

    initGalleryAutoplay() {
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplayInterval = parseInt(this.dataset.autoplayInterval, 10) || 5000;
      this.resumeDelay = 6000;
      if (!this.autoplayEnabled) return;
      if (!this.mobileSlider || this.mediaSlides.length < 2) return;
      // Reduced-motion degrades, it doesn't disable: the timer keeps running and
      // the CSS only softens the (opacity-only) crossfade. Bailing out here would
      // leave the gallery frozen for anyone with the OS "Reduce Motion" setting on.
      this.reduceMotionMql = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.inView = true;

      // Pause briefly after any manual interaction, then resume.
      ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => {
        this.mobileSlider.addEventListener(ev, () => { this.resumeAt = Date.now() + this.resumeDelay; }, { passive: true });
      });
      // Kept as a stored ref so disconnectedCallback can remove it — otherwise this
      // document-level listener (and the matchMedia one below) survives section
      // re-render in the Theme Editor and keeps a detached gallery + its timers alive.
      this._onVisibilityChange = () => {
        if (document.hidden) this.stopGalleryTimer();
        else this.startGalleryAutoplay();
      };
      document.addEventListener('visibilitychange', this._onVisibilityChange);
      if ('IntersectionObserver' in window) {
        this.galleryIO = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
        }, { threshold: 0.4 });
        this.galleryIO.observe(this);
      }
      this.startGalleryAutoplay();
    }

    startGalleryAutoplay() {
      if (!this.autoplayEnabled || this.galleryTimer) return;
      this.galleryTimer = setInterval(() => {
        if (document.hidden || !this.inView) return;
        if (this.resumeAt && Date.now() < this.resumeAt) return;
        this.advanceGallery();
      }, this.autoplayInterval);
    }

    stopGalleryTimer() {
      if (this.galleryTimer) {
        clearInterval(this.galleryTimer);
        this.galleryTimer = null;
      }
    }

    // Index of the currently cross-faded (is-active) slide.
    galleryActiveIndex() {
      const active = this.elements.viewer.querySelector('.product__media-item.is-active');
      const i = this.mediaSlides.indexOf(active);
      return i < 0 ? 0 : i;
    }

    // Cross-fade to a slide by index (wraps around). Fade + reduced-motion are
    // handled in CSS; here we only move the is-active class + sync the counter.
    // Incoming embeds are NOT eagerly loaded — the slide's own poster button
    // does that on tap; we only pause whatever was already playing.
    goToGallerySlide(index) {
      const slides = this.mediaSlides;
      const n = slides.length;
      if (n < 2) return;
      const target = slides[((index % n) + n) % n];
      if (!target || target.classList.contains('is-active')) return;
      slides.forEach((s) => s.classList.remove('is-active'));
      target.classList.add('is-active');
      this.pausePlayingMedia();
      this.syncTakeoverState();
    }

    // Re-sync the 1/N counter + nav-overlay mode to whichever slide is active.
    // Also called from outside the crossfade path (e.g. a variant switch that
    // lands on the variant's featured image via setActiveMedia).
    syncTakeoverState() {
      this.updateCounter();
      if (this.navOverlay) {
        this.navOverlay.classList.toggle(
          'gallery-nav-overlay--media',
          this.isMediaSlide(this.mediaSlides[this.galleryActiveIndex()])
        );
      }
    }

    // Build the two 50%-width overlay halves (left = prev, right = next) that
    // replace tap-to-zoom on mobile. Hidden on desktop via CSS (display:none).
    initGalleryClickCycle() {
      if (!this.mobileSlider || this.mediaSlides.length < 2) return;
      const overlay = document.createElement('div');
      overlay.className = 'gallery-nav-overlay';
      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'gallery-nav-half gallery-nav-half--prev';
      prev.setAttribute('aria-label', window.accessibilityStrings.previousImage);
      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'gallery-nav-half gallery-nav-half--next';
      next.setAttribute('aria-label', window.accessibilityStrings.nextImage);
      overlay.append(prev, next);
      this.elements.viewer.appendChild(overlay);
      this.navOverlay = overlay;
      // On a playable slide the halves shrink to edge strips (CSS) so the
      // poster/play controls receive the tap — set the initial state too.
      overlay.classList.toggle('gallery-nav-overlay--media', this.isMediaSlide(this.mediaSlides[this.galleryActiveIndex()]));

      const pauseAutoplay = () => {
        if (this.resumeDelay) this.resumeAt = Date.now() + this.resumeDelay;
      };
      prev.addEventListener('click', () => { pauseAutoplay(); this.goToGallerySlide(this.galleryActiveIndex() - 1); });
      next.addEventListener('click', () => { pauseAutoplay(); this.goToGallerySlide(this.galleryActiveIndex() + 1); });
    }

    advanceGallery() {
      if (this.mediaSlides.length < 2) return;
      const i = this.galleryActiveIndex();
      // Never yank a playable slide away mid-watch, and never auto-advance
      // INTO one (its embed would load and the play state would be lost on
      // the next tick) — autoplay cycles images only; taps reach the rest.
      if (this.isMediaSlide(this.mediaSlides[i])) return;
      for (let step = 1; step < this.mediaSlides.length; step++) {
        const candidate = this.mediaSlides[(i + step) % this.mediaSlides.length];
        if (!this.isMediaSlide(candidate)) {
          this.goToGallerySlide(i + step);
          return;
        }
      }
    }

    disconnectedCallback() {
      this.stopGalleryTimer();
      if (this.galleryIO) this.galleryIO.disconnect();
      if (this._onVisibilityChange) document.removeEventListener('visibilitychange', this._onVisibilityChange);
    }
  });
}